/* eslint-disable @typescript-eslint/prefer-literal-enum-member */
export enum ViewerProductTypes {
  None = 'None',
  DigitalResourcesGum2021 = 'DigitalResourcesGum2021',
  DigitalResourcesSpelling2016 = 'DigitalResourcesSpelling2016',
  DigitalResourcesSpelling2020Texas = 'DigitalResourcesSpelling2020Texas',
  DigitalResourcesSpelling2020TexasSample = 'DigitalResourcesSpelling2020TexasSample',
  DigitalResourcesSpelling2022 = 'DigitalResourcesSpelling2022',
  DigitalResourcesHandwriting2016 = 'DigitalResourcesHandwriting2016',
  DigitalResourcesHandwriting2020 = 'DigitalResourcesHandwriting2020',
  DigitalResourcesHandwriting2025 = 'DigitalResourcesHandwriting2025',
  DigitalResourcesHandwriting2020Texas = 'DigitalResourcesHandwriting2020Texas',
  DigitalResourcesHandwriting2020TexasSample = 'DigitalResourcesHandwriting2020TexasSample',
  DigitalResourcesHandwriting2026Texas = 'DigitalResourcesHandwriting2026Texas',
  DigitalResourcesLaEscritura2020 = 'DigitalResourcesLaEscritura2020',
  DigitalResourcesLaEscritura2020Texas = 'DigitalResourcesLaEscritura2020Texas',
  DigitalResourcesLaEscritura2020TexasSample = 'DigitalResourcesLaEscritura2020TexasSample',
  DigitalResourcesLaEscritura2026Texas = 'DigitalResourcesLaEscritura2026Texas',
  DigitalResourcesSuperkids2015 = 'DigitalResourcesSuperkids2015',
  DigitalResourcesSuperkids2017 = 'DigitalResourcesSuperkids2017',
  DigitalResourcesSuperkids2026 = 'DigitalResourcesSuperkids2026',
  DigitalResourcesSuperkidsFsk  = 'DigitalResourcesSuperkidsFsk',
  DigitalResourcesSuperkidsHea = 'DigitalResourcesSuperkidsHea',
  DigitalResourcesKickstartNumberSense2021 = 'DigitalResourcesKickstartNumberSense2021',
  DigitalResourcesKickstartNumberSense2021AL = 'DigitalResourcesKickstartNumberSense2021AL',
  DigitalResourcesKickstartEarlyNumberAndCounting2023 = 'DigitalResourcesKickstartEarlyNumberAndCounting2023',
  DigitalResourcesKickstartEarlyNumberAndCounting2023AL = 'DigitalResourcesKickstartEarlyNumberAndCounting2023AL',
  DigitalResourcesKickstartFractions2026 = 'DigitalResourcesKickstartFractions2026',
  DigitalResourcesKickstartFractions2026AL = 'DigitalResourcesKickstartFractions2026AL',
  DigitalResourcesKickstartOperations2026 = 'DigitalResourcesKickstartOperations2026',
  DigitalResourcesKickstartOperations2026AL = 'DigitalResourcesKickstartOperations2026AL',
  DigitalResourcesMindscapes2024 = 'DigitalResourcesMindscapes2024',
  DigitalResourcesEce2024 = 'DigitalResourcesEce2024',
  DigitalResourcesBff2025 = 'DigitalResourcesBff2025',
  DigitalResourcesBff2025AL = 'DigitalResourcesBff2025AL',
  DigitalResourcesIReadToWrite2021 = 'DigitalResourcesIReadToWrite2021',
  DigitalResourcesJumpIntoWriting2021 = 'DigitalResourcesJumpIntoWriting2021',
  DigitalResourcesWordHeroes2017 = 'DigitalResourcesWordHeroes2017',
  DigitalResourcesWordWisdom2017 = 'DigitalResourcesWordWisdom2017',
}

export enum ViewerProductTypesMap {
  None = ViewerProductTypes.None,
  GUM2021N = ViewerProductTypes.DigitalResourcesGum2021,
  SPCN2016N = ViewerProductTypes.DigitalResourcesSpelling2016,
  SPCN2020TX = ViewerProductTypes.DigitalResourcesSpelling2020Texas,
  SPCN2020TXS = ViewerProductTypes.DigitalResourcesSpelling2020TexasSample,
  SPCN2022N = ViewerProductTypes.DigitalResourcesSpelling2022,
  SPCN2022 = ViewerProductTypes.DigitalResourcesSpelling2022,
  HW2020N = ViewerProductTypes.DigitalResourcesHandwriting2020,
  HW2020 = ViewerProductTypes.DigitalResourcesHandwriting2020,
  HW2025N = ViewerProductTypes.DigitalResourcesHandwriting2025,
  HW2020TX = ViewerProductTypes.DigitalResourcesHandwriting2020Texas,
  HW2020TXS = ViewerProductTypes.DigitalResourcesHandwriting2020TexasSample,
  HW2026TX = ViewerProductTypes.DigitalResourcesHandwriting2026Texas,
  LAESC2020N = ViewerProductTypes.DigitalResourcesLaEscritura2020,
  LAESC2020 = ViewerProductTypes.DigitalResourcesLaEscritura2020,
  LAESC2020TX = ViewerProductTypes.DigitalResourcesLaEscritura2020Texas,
  LAESC2020TXS = ViewerProductTypes.DigitalResourcesLaEscritura2020TexasSample,
  LAESC2026TX = ViewerProductTypes.DigitalResourcesLaEscritura2026Texas,
  SK2015 = ViewerProductTypes.DigitalResourcesSuperkids2015,
  SK2017 = ViewerProductTypes.DigitalResourcesSuperkids2017,
  SK2026 = ViewerProductTypes.DigitalResourcesSuperkids2026,
  FSK2021 = ViewerProductTypes.DigitalResourcesSuperkidsFsk,
  HEA2011 = ViewerProductTypes.DigitalResourcesSuperkidsHea,
  KNS2021 = ViewerProductTypes.DigitalResourcesKickstartNumberSense2021,
  KNS2021AL = ViewerProductTypes.DigitalResourcesKickstartNumberSense2021AL,
  KENC2023 = ViewerProductTypes.DigitalResourcesKickstartEarlyNumberAndCounting2023,
  KENC2023AL = ViewerProductTypes.DigitalResourcesKickstartEarlyNumberAndCounting2023AL,
  KF2026 = ViewerProductTypes.DigitalResourcesKickstartFractions2026,
  KF2026AL = ViewerProductTypes.DigitalResourcesKickstartFractions2026AL,
  KO2026 = ViewerProductTypes.DigitalResourcesKickstartOperations2026,
  KO2026AL = ViewerProductTypes.DigitalResourcesKickstartOperations2026AL,
  MS2024 = ViewerProductTypes.DigitalResourcesMindscapes2024,
  ECE2024 = ViewerProductTypes.DigitalResourcesEce2024,
  BFF2025 = ViewerProductTypes.DigitalResourcesBff2025,
  BFF2025AL = ViewerProductTypes.DigitalResourcesBff2025AL,
  IRTW2021N = ViewerProductTypes.DigitalResourcesIReadToWrite2021,
  JIW2021N = ViewerProductTypes.DigitalResourcesJumpIntoWriting2021,
  WH2017N = ViewerProductTypes.DigitalResourcesWordHeroes2017,
  WW2017N = ViewerProductTypes.DigitalResourcesWordWisdom2017,
}
